import { jsx as _jsx } from "react/jsx-runtime";
import { flexRender } from '@tanstack/react-table';
import { getCellStylesFromCtx } from '../../../../../infra/ui/table/utils';
import styles from './styles.module.scss';
export var TableRow = function (_a) {
    var row = _a.row, onRowClick = _a.onRowClick;
    return (_jsx("button", { onClick: function () { return onRowClick(row); }, className: styles.tr, children: row.getVisibleCells().map(function (cell) { return (_jsx("div", { className: "td", style: getCellStylesFromCtx({ ctx: cell.getContext(), stretchItems: 'flex' }), children: flexRender(cell.column.columnDef.cell, cell.getContext()) }, cell.id)); }) }));
};
